<div class="wrapper">
  <div class="main">
    {{ factValue() }}
  </div>
  <div class="additional">
    <span>
      {{ published() }}
    </span>
    <span>/</span>
    <span>
      {{ expected() }}
    </span>
  </div>
</div>
